import { Outlet } from "react-router-dom";

export const AgentsLayout = (): JSX.Element => {
  return (
    <div className="relative w-full overflow-auto flex-1">
      <Outlet />
    </div>
  );
};
